import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { headerLinksTexts } from "../../Components/Common/Header";
import PhoneHeader from "../../Components/Common/PhoneHeader";
import BillInquire from "../../Components/Payment/BillInquire";
import Bills, {
  editBill,
  EditModule,
  Module,
  removeBill,
} from "../../Components/Payment/Bills";
import { setBillInfo } from "../../Redux/Actions";
import { ApiCall } from "../../Redux/Actions/ApiCall";
import { urls } from "../../Utils/url";

export const getBills = (setBills, token, setBillsLoading) => {
  setBillsLoading(true);
  ApiCall(
    "get",
    `${urls.GetUserBills}`,
    null,
    "GetBills",
    token,
    function (e) {
      const data = e.data;
      setBills(data);
      setBillsLoading(false);
      // document.getElementById("companyImage") &&
      //   window.scrollTo({
      //     top: document.getElementById("companyImage").offsetTop,
      //     behavior: "smooth"
      //   });
    },
    function (error) {
      setBillsLoading(false);
    }
  );
};
export const getBillStatus = (billId, token, setPaymentStatus) => {
  ApiCall(
    "get",
    `${urls.BillStatus}${billId}`,
    null,
    "getBillStatus",
    token,
    function (e) {
      setPaymentStatus(e.data.payment_status);
    }
  );
};

const PaymentComponent = ({
  moduleVisible,
  setModuleVisible,
  billsLoading,
  setModuleID,
  moduleID,
  billId,
  companyId,
  setBillId,
  setPayment,
  setBillName,
  setAmount,
  filteredBills,
  isLogin,
  token,
  setBills,
  setDate,
  setInfo,
  loading,
  setLoading,
  setEditModuleVisible,
  editModuleVisible,
  billTitle,
  setBillTitle,
  selectedBillId,
  setSelectedBillId,
  bills,
  setBillParam,
  history,
  setBillToPay,
}) => {
  return (
    <>
      <BillInquire
        value={billId}
        // header={header}
        companyId={companyId}
        setBillId={setBillId}
        setPayment={setPayment}
        setBillName={setBillName}
        setAmount={setAmount}
        isLogin={isLogin}
        setDate={setDate}
        setInfo={setInfo}
        setLoading={setLoading}
        loading={loading}
        setBillParam={setBillParam}
        history={history}
        setBillToPay={setBillToPay}
      />

      <Bills
        bills={filteredBills}
        billsLoading={billsLoading}
        onClick={setBillId}
        onClickName={setBillName}
        setModuleID={setModuleID}
        setModuleVisible={setModuleVisible}
        setEditModuleVisible={setEditModuleVisible}
        setBillTitle={setBillTitle}
        setSelectedBillId={setSelectedBillId}
      />

      {moduleVisible && (
        <Module
          onClickNo={() => setModuleVisible(false)}
          onClickYes={() => {
            removeBill(moduleID, token, setBills, companyId, bills);
            setModuleVisible(false);
          }}
        />
      )}
      {editModuleVisible && (
        <EditModule
          onClickNo={() => setEditModuleVisible(false)}
          onClickYes={() => {
            editBill(billTitle, token, selectedBillId, bills, setBills);
            setEditModuleVisible(false);
          }}
          setBillTitle={setBillTitle}
          value={billTitle}
        />
      )}
    </>
  );
};

function Payment({ isLogin, setBillToPay, token }) {
  const history = useHistory();
  const [billId, setBillId] = useState([]);
  const [billParam, setBillParam] = useState("");
  const [billsLoading, setBillsLoading] = useState(false);
  const [date, setDate] = useState("");
  const [info, setInfo] = useState("");
  const [bills, setBills] = useState("");
  const [selectedBillId, setSelectedBillId] = useState("");
  const [billName, setBillName] = useState("");
  const [amount, setAmount] = useState("");
  const [moduleVisible, setModuleVisible] = useState(false);
  const [editModuleVisible, setEditModuleVisible] = useState(false);
  const [moduleID, setModuleID] = useState("");
  const [loading, setLoading] = useState(false);
  const [billTitle, setBillTitle] = useState("");
  const standalone = window.matchMedia("(display-mode: standalone)").matches;
  useEffect(() => {
    if (standalone) {
      history.push("/addtohome");
    } else if (!isLogin) {
      history.push("/login");
    }
    window.scrollTo(0, 0);
  }, []);
  const currentPage = headerLinksTexts.filter(
    (i) => i.path === history.location.pathname
  )[0];
  const companyId = currentPage.companyId;
  useEffect(() => {
    var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    (window.orientation == 90 || window.orientation == -90) &&
      isMobile &&
      history.push("/rotate");
    window.addEventListener(
      "orientationchange",
      function () {
        var isForbidden =
          (window.orientation == 90 || window.orientation == -90) && isMobile;
        if (isForbidden) {
          history.push("/rotate");
        }
      },
      false
    );
  }, []);
  useEffect(() => {
    let isSubscribed = true;
    if (isSubscribed) {
      isLogin &&
        window.navigator.onLine &&
        getBills(setBills, token, setBillsLoading);
    }
    return () => {
      isSubscribed = false;
    };
  }, [token, isLogin]);

  useEffect(() => {
    let isSubscribed = true;
    if (isSubscribed) {
      window.scrollTo(0, 0);
      isLogin &&
        window.navigator.onLine &&
        getBills(setBills, token, setBillsLoading);
      setModuleVisible(false);
      setModuleID("");
      setLoading(false);
      setBillId("");
      setBillName("");
      setAmount("");
    }
    return () => {
      isSubscribed = false;
    };
  }, [history.location, token, isLogin]);

  const filteredBills =
    bills && bills.filter((i) => i.bill_company_id === companyId);
  return (
    <div className="Container">
      <div
        className="mobileContainer"
        style={{ paddingTop: window.innerHeight * 0.1 }}
      >
        <PhoneHeader text={"استعلام قبض"} />
        <div className="PaymentPage">
          <PaymentComponent
            setModuleVisible={setModuleVisible}
            setModuleID={setModuleID}
            moduleID={moduleID}
            moduleVisible={moduleVisible}
            setBills={setBills}
            amount={amount}
            billName={billName}
            billId={billId}
            companyId={companyId}
            setBillId={setBillId}
            setBillName={setBillName}
            setAmount={setAmount}
            filteredBills={filteredBills}
            isLogin={isLogin}
            token={token}
            date={date}
            setDate={setDate}
            info={info}
            // header={header}
            billTitle={billTitle}
            setBillTitle={setBillTitle}
            setInfo={setInfo}
            loading={loading}
            bills={bills}
            setLoading={setLoading}
            editModuleVisible={editModuleVisible}
            setEditModuleVisible={setEditModuleVisible}
            selectedBillId={selectedBillId}
            setSelectedBillId={setSelectedBillId}
            billParam={billParam}
            setBillParam={setBillParam}
            history={history}
            billsLoading={billsLoading}
            setBillToPay={setBillToPay}
          />
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    bills: state.persistedParams.bills,
    token: state.auth.token,
    Open: state.init.loginOpen,
    isLogin: state.auth.isLogin,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    setBillToPay: (info) => dispatch(setBillInfo(info)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Payment);
